import { useMemo } from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useHourlyRequests } from '../../hooks';
import { tooltipStyle, labelStyle } from '../AnalyticsComponents/analyticsUtils';

function getYesterdayRange() {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const formatDate = date => date.toISOString().split('T')[0];
  return { start_date: formatDate(yesterday), end_date: formatDate(today) };
}

export function HourlyChart({ enabled = true }) {
  const { start_date, end_date } = getYesterdayRange();
  const { data: hourlyData, isPending } = useHourlyRequests(start_date, end_date, { enabled });

  const chartData = useMemo(() => {
    if (!hourlyData?.hourly?.length) return [];
    return hourlyData.hourly
      .map(item => {
        const date = new Date(item.timestamp);
        return {
          hour: `${date.getHours().toString().padStart(2, '0')}:00`,
          requests: item.count ?? 0,
        };
      })
      .sort((a, b) => a.hour.localeCompare(b.hour))
      .filter(item => parseInt(item.hour.split(':')[0], 10) % 2 === 0);
  }, [hourlyData?.hourly]);

  return (
    <div className="p-6 rounded-xl bg-white border border-shell-border">
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-ink">Today&apos;s Traffic</h3>
        <p className="text-xs text-mute mt-0.5">Requests per 24-hour window</p>
      </div>

      {isPending ? (
        <div className="h-[280px] rounded-lg bg-paper border border-shell-border animate-pulse" />
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#262626" vertical={false} />
            <XAxis dataKey="hour" stroke="#707070" fontSize={11} tickLine={false} axisLine={false} />
            <YAxis
              stroke="#707070"
              fontSize={11}
              axisLine={false}
              tickLine={false}
              tickFormatter={v => `${(v / 1000).toFixed(0)}k`}
            />
            <Tooltip contentStyle={tooltipStyle} labelStyle={labelStyle} />
            <Bar dataKey="requests" fill="#3B82F6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
